<template>
	<c-dialog ref="dialog" :title="this.gift?'赠品库':'商品库'" width="900" @resolve="resolve">
		<m-search ref="search" @search="search">
			<c-form ref="form" inline>
				<c-form-item type="input" label="商品名称" name="product_name"></c-form-item>
				<c-form-item type="input" label="货号" name="product_itemnumber"></c-form-item>
				<c-form-item v-if="!this.gift" type="checkbox" label="状态" name="state" :options="dict.productStateCheck"></c-form-item>
			</c-form>
		</m-search>
			
		<c-table ref="table" height="400">
			<c-table-column
				type="selector"
				:multiple="!!multiple"
			></c-table-column>
			
			<c-table-column
				v-if="!sku"
				label="状态"
				name="state"
				width="80"
			>
				<template v-slot="{data}">
					<span v-if="data.state == 2" style="color:green">{{dict.productState[data.state]}}</span>
					<span v-if="data.state == 1" style="color:gray">{{dict.productState[data.state]}}</span>
					<span v-if="data.state == 0" style="color:red">{{dict.productState[data.state]}}</span>
				</template>
			</c-table-column>
			
			<c-table-column
				label="商品信息"
				width="200"
			>
				<template v-slot="{data}">
					<product-info :image="data.product_img_url" :name="data.product_name"></product-info>
				</template>
			</c-table-column>
			
			<c-table-column
				label="货号"
				name="product_itemnumber"
				width="80"
			></c-table-column>
			
			<c-table-column
				v-if="sku"
				label="规格名称"
				name="product_sku_spec"
				width="200"
			></c-table-column>

			<c-table-column
				v-if="!sku"
				label="所属分类"
				name="product_type_full_name"
				width="120"
			></c-table-column>
			
			<c-table-column
				label="售价(元)"
				name="product_price"
				width="110"
			>
				<template v-slot="{data}">
					￥{{data.product_price}}
				</template>
			</c-table-column>

			<c-table-column
				  v-if="sku"
				  label="商品库存"
				  name="stock_count"
				  width="80"
			></c-table-column>
			
			<c-table-column
				v-if="!sku"
				label="创建时间"
				name="create_date"
				width="140"
			></c-table-column>
			
			<c-table-column
				v-if="!sku"
				label="上下架时间"
				name="sell_state_date"
				width="140"
			></c-table-column>
		</c-table>
	</c-dialog>
</template>

<script>
	import productInfo from '@/components/public/product_info.vue'
	import {mapState} from 'vuex'
	
	export default {
		components: {
			productInfo
		},
		
		props: {
			sku: Boolean,
			multiple: Boolean,
			gift: Boolean
		},
		
		computed: {
			...mapState(['dict'])
		},
		
		methods: {
			search(data) {
				if(this.gift){
					data.is_gift = 1;
				}
				this.$refs.table.load({
					url: this.sku ? '/points_product/productList' : '/product/list',
					data
				});
			},
			
			open() {
				this.$refs.form.clear();
				this.$refs.search.search();
				this.$refs.dialog.open();
			},
			
			resolve(stop) {
				var data = this.$refs.table.getRow('selected');
				if (!data.length) {
					stop();
					this.$message({
						text: '请选择商品'
					});
					return;
				}
				this.$emit('resolve', Array.from(data, item => item.data));
			}
		}
	}
</script>